import React from "react";

const Spinner = () => {
  return <span className="loader"></span>;
};

export default Spinner;
